import { Button, ButtonGroup, Modal } from "@datapay-by-datacom/design-system";
import { Heading } from "react-aria-components";
import styles from "./CancelImportConfirmModal.module.css";

interface CancelImportConfirmModalProps {
  isOpen: boolean;
  onKeepImporting: () => void;
  onCancelAnyway: () => void;
}

/** Confirms abandoning an in-progress pay component import (Cancel import). */
export function CancelImportConfirmModal({
  isOpen,
  onKeepImporting,
  onCancelAnyway,
}: CancelImportConfirmModalProps) {
  return (
    <Modal isOpen={isOpen}>
      <div className={styles.modalContent}>
        <div className={styles.modalHeader}>
          <Heading slot="title">Cancel import?</Heading>
        </div>

        <p className={styles.message}>
          You have an import in progress. If you cancel now, your uploaded rows,
          mappings, and validation progress will be lost.
        </p>

        <div className={styles.actions}>
          <ButtonGroup>
            <Button variant="primary" onPress={onKeepImporting}>
              Keep importing
            </Button>
            <Button variant="tertiary" onPress={onCancelAnyway}>
              Cancel anyway
            </Button>
          </ButtonGroup>
        </div>
      </div>
    </Modal>
  );
}
